import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CmAuthService } from '../services';

export interface UnsavedChangesCheck {
	canDeactivate(): Observable<boolean>;
}

@Injectable()
export class CmUnsavedChangesGuard implements CanDeactivate<UnsavedChangesCheck> {
	constructor(private auth: CmAuthService) {}

	canDeactivate(component: UnsavedChangesCheck): Observable<boolean> {
		return this.auth.token$.pipe(
			switchMap(authenticated =>
				iif(() => authenticated && !!component.canDeactivate, component.canDeactivate(), of(true))
			)
		);
	}
}
